const defaultSettings = (login: boolean) => {
  var settings;
  if (login) {
    settings = {
      navTheme: 'light',
      layout: 'mix',
      primaryColor: '#13c2c2',
    };
  } else {
    settings = {
      navTheme: 'light',
      layout: 'mix',
      primaryColor: '#13c2c2',
      menuRender: false,
    };
  }
  return settings;
};

export default defaultSettings;
